import moment from 'moment';
import isNumber from 'lodash/isNumber';
import reactCookie from 'react-cookies';
import { isEmpty } from 'lodash';

export function setVMCityCookie(city) {
  const date = moment()
    .add('30', 'days')
    .endOf('day');
  reactCookie.save('vmusercity', city, {
    path: '/',
    expires: date.toDate(),
    maxAge: date.diff(moment(), 'seconds'),
  });
}

export function setEventCookie(date, eventId) {
  const eventDate = moment(date)
    .endOf('day');
  reactCookie.save('vmeventid', eventId, {
    path: '/',
    maxAge: eventDate.diff(moment(), 'seconds'),
    expires: eventDate.toDate(),
  });
}

export function saveRecentSearch(searches) {
  const date = moment()
    .add(6, 'M');
  reactCookie.save('vmRecentSearches', JSON.stringify(searches),
    {
      path: '/',
      maxAge: date.diff(moment(), 'seconds'),
      expires: date.toDate(),
    },
  );
}

export function setNoPopup(r) {
  const date = moment()
    .add(30, 'minutes');
  reactCookie.save('vmPopUpValue', r,
    {
      path: '/',
      maxAge: date.diff(moment(), 'seconds'),
      expires: date.toDate(),
    },
  );
}

export function loadNoPopup() {
  return reactCookie.load('vmPopUpValue');
}

export function loadVmUserCity() {
  return reactCookie.load('vmusercity');
}

export function loadVmEventId() {
  return reactCookie.load('vmeventid');
}


export function loadVmLeadTrackContent() {
  return reactCookie.load('vmleadtrack');
}

export function loadVmRecentSearches() {
  return reactCookie.load('vmRecentSearches');
}

export function removeEventId() {
  reactCookie.remove('vmeventid', { path: '/' });
}

export function vmLeadformCountStats() {
  const date = moment()
    .add(1, 'hours');
  let count = reactCookie.load('vmleadformstatscount');
  if (isNumber(count)) {
    // stats = JSON.parse(stats);
    count = parseInt(count, 10) + 1;
    reactCookie.save('vmleadformstatscount', count, {
      path: '/',
      maxAge: date.diff(moment(), 'seconds'),
      expires: date.toDate(),
    });
  } else {
    reactCookie.save('vmleadformstatscount', 1, {
      path: '/',
      maxAge: date.diff(moment(), 'seconds'),
      expires: date.toDate(),
    });
  }
}

export function vmLeadformTimeStats() {
  const date = moment()
    .add(1, 'hours');
  let stats = reactCookie.load('vmleadformstatstime');
  if (!!!stats) {
    reactCookie.save('vmleadformstatstime', Date.now(), {
      path: '/',
      maxAge: date.diff(moment(), 'seconds'),
      expires: date.toDate(),
    });
  }
}

export function setVmLeadTrackContent(input) {
  let trackedData = loadVmLeadTrackContent()
  if(trackedData && !isEmpty(trackedData) ){
    if(!input.utm_campaign){
      return
    }
    if (input.utm_campaign !== trackedData.utm_campaign){
      // input.landingPage = trackedData.landingPage
      const date = moment().add(1, 'hours');
      const stringInput = JSON.stringify(input);
      reactCookie.save('vmleadtrack', stringInput, {
        path: '/',
        maxAge: date.diff(moment(), 'seconds'),
        expires: date.toDate(),
      });
    } 
  }
  else{
    const date = moment().add(1, 'hours');
    const stringInput = JSON.stringify(input);
    reactCookie.save('vmleadtrack', stringInput, {
      path: '/',
      maxAge: date.diff(moment(), 'seconds'),
      expires: date.toDate(),
    });
  }
  
}

export function loadvmLeadformCountStats() {
  return reactCookie.load('vmleadformstatscount');
}

export const setCurrentPage = (page)=>{
  reactCookie.save('currentPage', page, {
      path: '/',
    });
}

export const getCurrentPage = ()=>{
  return reactCookie.load('currentPage')
}

export function loadvmLeadformTimeStats() {
  return reactCookie.load('vmleadformstatstime');
}


export function setVmFormCountForBlog(value) {
  const date = moment()
    .add(24, 'hours');
  reactCookie.save('vmFormCountForBlog', value, {
    path: '/blog',
    maxAge: date.diff(moment(), 'seconds'),
    expires: date.toDate(),
  });
}
export function getVmFormCountForBlog() {
  return reactCookie.load('vmFormCountForBlog');
}

export function loadTrackingCookieName() {
  return reactCookie.load('vm_jasoos');
}
